import React from 'react';
import {Link as RouterLink, Redirect, Route, Switch} from 'react-router-dom';
import blueprintDefinition from '../lib/blueprint.definition';
import BlueprintReviewPanel from './BlueprintReviewPanel';
import auth from '../lib/auth';
import {actions} from '../store';
import store from '../store';
import * as helpers from '../lib/helpers';
import Panel from '../components/Panel';

export default class BlueprintReview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
      submitting: false,
      blueprint: {},
    };

    const {match} = props;
    this.groupId = match.params.groupId;
    this.blueprintId = match.params.blueprintId;
    this.done = false;
    this.blueprintDefinition = [];
    this.renderDoneScreen = this.renderDoneScreen.bind(this);
  }

  async componentDidMount() {
    let [blueprint, user] = await Promise.all([
      store.dispatch(actions.blueprints.fetch({
        groupId: this.groupId,
        blueprintId: this.blueprintId,
      })),
      auth.user(),
    ]);
    this.blueprintDefinition = blueprintDefinition[blueprint.type];
    this.setState({
      initializing: false,
      blueprint,
      user,
    });
  }

  handleBack(previous) {
    this.props.history.push(
        `/blueprints/review/${this.groupId}/${this.blueprintId}/${previous}`);
  }


  saveBlueprint(next, changedValues, newAudit) {
    next = next || 'done';
    store.dispatch(actions.blueprints.updateCurrentValues(changedValues));
    store.dispatch(actions.blueprints.updateCurrentAudit(newAudit));
    this.setState({
      submitting: true,
    });

    store.dispatch(actions.blueprints.submit()).then((result) => {
      this.done = next === 'done';
      this.props.history.push(
          `/blueprints/review/${this.groupId}/${this.blueprintId}/${next}`);
      this.setState({
        submitting: false,
      });
    }).catch(err => {
      alert(err.message);
      this.setState({
        submitting: false,
      });
    });
  }

  createNavigationItem({page, icon, label}) {
    let {match} = this.props;
    let selectedPage = match.params.page || 'domain-ssl';
    let isActive = selectedPage === page;
    let path = `/blueprints/review/${this.groupId}/${this.blueprintId}/${page}`;
    return (
        <li className={isActive ? 'active' : ''}
            key={page}
            onClick={() => this.props.history.push(path)}>
          <img src={icon} alt={label} height={22}/>
          <RouterLink
              to={path}
              onClick={(e) => e.stopPropagation()}
          >
            {label}
          </RouterLink>
        </li>
    );
  }

  renderDoneScreen(){
    return this.done ? (
        <Panel title="Blueprint Reviewed!">
          <div className="text-center">
            <h4>Thank you for your submission! You may click <RouterLink to={`/blueprints/review/${this.groupId}/${this.blueprintId}`} style={{fontSize:'inherit'}}>here</RouterLink> to go back to start of review.</h4>
          </div>
        </Panel>
    ) : (
        <Redirect
            to={`/blueprints/review/${this.groupId}/${this.blueprintId}/domain-ssl`}
        />
    );
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : (
        <div className="BlueprintReview">
          <div className="skip-Summary">
            <div className="Summary-sec">
              <div className="row">
                <div className="col-md-12">
                  <ul className="documents-menu">
                    {
                      this.blueprintDefinition.map(
                          (block) => {
                            return this.createNavigationItem({
                              page: block.slug,
                              icon: `/img/${block.slug}-icon.svg`,
                              label: block.shortName,
                            });
                          })
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Switch>
            {(() => {
              let slugStack = this.blueprintDefinition.map((block) => block.slug);

              return this.blueprintDefinition.map((block, index) => {
                let previous = index > 0 ? slugStack[index - 1] : null;
                let next = index < slugStack.length - 1 ?
                    slugStack[index + 1] :
                    null;

                return (<Route
                    path={`/blueprints/review/${this.groupId}/${this.blueprintId}/${block.slug}`}
                    render={(props) => <BlueprintReviewPanel {...props}
                                                             user={this.state.user}
                                                             blueprint={this.state.blueprint}
                                                             submitting={this.state.submitting}
                                                             block={block}
                                                             onNext={next ?
                                                                 this.saveBlueprint.bind(
                                                                     this,
                                                                     next) :
                                                                 null}
                                                             onBack={previous ?
                                                                 this.handleBack.bind(
                                                                     this,
                                                                     previous) :
                                                                 null}
                                                             onSubmit={!next ?
                                                                 this.saveBlueprint.bind(
                                                                     this,null) :
                                                                 null}/>
                    }
                    key={block.slug}
                />);
              });
            })()}
            <Route exact path="/blueprints/review/:groupId/:blueprintId/done"
                   render={this.renderDoneScreen}
            />
            <Route exact path="/blueprints/review/:groupId/:blueprintId"
                   render={
                     (props) => <Redirect
                         to={`/blueprints/review/${this.groupId}/${this.blueprintId}/${this.blueprintDefinition[0].slug}`}
                     />
                   }
            />
          </Switch>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/BlueprintReview.js